export default __webpack_public_path__ + "static/media/plus-img.d37bb261.svg";